import {
  useCallback, useEffect, useState, useMemo, useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { message } from 'antd';

import devicesAlarmApi from '@api/devicesAlarmApi';
import deviceActions from '@state/device/actions';

function useDeviceAlarms() {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();

  const deviceList = useSelector(({ device: a }) => a.deviceList);
  const offset = useSelector(({ device: a }) => a.offset);
  const limit = useSelector(({ device: a }) => a.limit);
  const deviceListCount = useSelector(({ device: a }) => a.count);
  const search = useSelector(({ device: a }) => a.search);

  const isFirstTime = useRef(true);
  const timeout = useRef(null);
  const abortController = useRef(null);
  const unmountcomponent = useRef(true);

  const [loading, setLoading] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);

  const [valueFilter, setValueFilter] = useState('');
  const [deviceListArr, setDeviceListArr] = useState([]);

  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const breadcrumbData = useMemo(() => {

    const currentSection = t('views.dynamic_alarms_create_edit.breadcrumb.gateway_rules');

    return [
      [null, currentSection],
    ];

  }, [t]);

  const hasMore = useMemo(() => {

    if (!deviceList) return true;
    return deviceList.length < deviceListCount;

  }, [deviceListCount, deviceList]);

  const onChangeSearch = useCallback(
    (event) => {

      const { value } = event.target;

      if (timeout.current) clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {

        dispatch(deviceActions.resetOffset());
        dispatch(deviceActions.setSearch(value));

      }, 1000);

    },
    // eslint-disable-next-line
    []
  );

  const goToCreate = useCallback(() => {

    history.push('/reglas/dispositivos/crear');
    // eslint-disable-next-line
  }, []);

  const requestAlarms = useCallback(
    ({ forNext = false } = {}) => {

      const abortC = new AbortController();
      const { signal } = abortC;
      abortController.current = abortC;

      const targetLoading = forNext ? setLoadingNext : setLoading;

      targetLoading(true);
      devicesAlarmApi
        .getAlarmsRules({
          offset, limit, search, signal,
        })
        .then((response) => {

          if (unmountcomponent) {

            const resp = {
              count: response.length,
              results: response,
            };
            const { count, results } = resp;
            dispatch(deviceActions.setAlarmsList({ count, results }));
            targetLoading(false);

          }

        })
        .catch((resError) => {

          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          targetLoading(false);

        });

    },
    [offset, limit, search, t, dispatch],
  );

  const abortRequest = useCallback(() => {

    const { current: abortC } = abortController;
    if (abortC) abortC.abort();

  }, []);

  const arrayFilter = deviceListArr.filter((data) => ( // Filter by name
    data.name.toUpperCase().includes(valueFilter.toUpperCase())
  ));

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();

}, []);

  useEffect(() => {

    if (!deviceList || isFirstTime.current) {

      isFirstTime.current = false;
      return;

    }

    requestAlarms();
    // eslint-disable-next-line consistent-return
    return abortRequest;
    // eslint-disable-next-line
  }, [search]);

  useEffect(() => {

    // if (!deviceList)
    requestAlarms();
    return abortRequest;
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    if (deviceList) {

      setDeviceListArr(deviceList);

}

  }, [deviceList]);

  useEffect(() => () => {

    unmountcomponent.current = false;

  });

  return {
    onChangeSearch,
    search,
    goToCreate,
    requestAlarms,
    deviceList,
    loading,
    hasMore,
    loadingNext,
    breadcrumbData,
    setValueFilter,
    arrayFilter,
    isCreate,
  };

}

export default useDeviceAlarms;
